import src from "IMAGE";
export default { src, width: 192, height: 192, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOElEQVR42q2OMQoAMAwC84PiUpw6+P9HFodApqZDblJBNOIHSYfkTm/tLGoAYKW3roUB2on25IsLHZEGCUxzfbcAAAAASUVORK5CYII="};
